import React from 'react';
import Modal, { ModalTransition } from '@atlaskit/modal-dialog';
import styled from 'styled-components';

import Button from 'kingpin/atoms/Button';

import VersionsTab from './VersionsTab';

// Version management as a modal rather than a tab: publishing, pinning and
// promoting are occasional acts, so they live behind the version button in the
// header rather than taking a permanent slot in the tab bar. The body is the
// same VersionsTab content — this only frames it and adds a close affordance.

const CloseRow = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 16px 24px 0 24px;
`;

const VersionsDialog = ({ close }: { close: () => void }) => (
  <ModalTransition>
    <Modal width="x-large" onClose={close} shouldScrollInViewport>
      <CloseRow>
        <Button type="Ghost" size="Small" label="Close" onClick={close} />
      </CloseRow>
      <VersionsTab />
    </Modal>
  </ModalTransition>
);

export default VersionsDialog;
